export default __webpack_public_path__ + "static/media/homeland.3ed72dca.png";